<template>
    <div>
        <div class="row">
            <div class="col-md-12 card-wrapper">
                <div class="card">
                    <div class="card-header crm-modal-header hpx-50 d-flex align-items-center">{{$ml.get('AUDIT_RECORD')}}</div>
                    <div class="card-body bg-light">
                        <div class="row">
                            <div class="col-12 " >
                                <div v-html="$ml.get('AUDIT_WARN')"></div>
                            </div>
                        </div>

                        <div class="row mt-4">
                            
                                <div class="align-self-center col-7">
                                    <button type="button" class="btn exportBtn bg-new-primary f-14 px-5 text-center" @click="exportEventLogsF" v-if="$can('can_export_data_from_lists')">
                                        {{$ml.get('EXPORT_AUDIT_EXCEL')}}</button>  
                                </div>
                               
                                <div class="ml-4 col-4">
                                    <vue-ctk-date-time-picker @input="setStartandEndDate()" :button-now-translation="$ml.get('TODAY')" class="new-ctk" id="dealreport" :label="$ml.get('SELECT_DATE')" v-model="selectDate" format="YYYY-MM-DD" formatted="ll" :noLabel="true" :range="true" :onlyDate="true" :auto-close="true"></vue-ctk-date-time-picker>
                                </div>    
                        </div>



                         <div class="table-wrapper mt-4">
                            <table class="table notification-table">
                                <thead>
                                    <tr>
                                        <th v-for="(col,inCol) in tableColumns" v-bind:key="inCol" >
                                            {{col.label}}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(row,inRow) in tableRows" v-bind:key="inRow">
                                        <td v-for="(col,inCol) in tableColumns" v-bind:key="inCol" >                                          
                                            <span v-if="col.type=='date'">{{row[col.prop].$date}}</span>
                                            <span v-else-if="col.type=='name'">{{row[col.prop].user}}</span>
                                            <span v-else-if="col.type=='process'">{{row[col.prop].message}}</span>
                                            <span v-else-if="col.type=='module'">{{row[col.prop].module}}</span>
                                        </td>
                                    </tr>

                                   
                                </tbody>
                            </table>
                         </div>






                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>



<script>

import Vue from 'vue';
import axios from 'axios'
import {mapGetters} from 'vuex'
import {mapState} from 'vuex'
import {mapActions} from 'vuex'
import data from '../../static/js/data';

    export default {
        components: {
       
        },
        data () {
        return {
            setDate:undefined,
            selectDate:{
                start:"",
                end:""
            },
            filter:{},
            tableRows:[],
            tableColumns:[

                {prop:'_message',label:this.$ml.get('USER'),type:"name"},
                {prop:'_message',label:this.$ml.get('PROCESS'),type:"process"},
                {prop:'_message',label:this.$ml.get('MODULE'),type:"module"},
                {prop:'eventTime',label:this.$ml.get('WHEN'),type:"date"}
            ],
            exportLang:"",
            exportBeginDate:"",
            exportEndDate:""
        }
    },
    watch: {
        bottom(bottom) {
            if (bottom) {
                    this.pagingOffset+=this.pagingSize
                    this.getEventLogs()
            }
        },
        permissions:function(){
            if(this.permissions===undefined){
                this.permissions=[]
            }
        }
    },
    created() {
        var today = new Date();
        var startOfWeek = new Date(today);
        startOfWeek.setDate(today.getDate() - today.getDay()+1);
        var startOfWeekFormatted = startOfWeek.toISOString().substring(0, 10);
        var endOfWeek = new Date(today);
        endOfWeek.setDate(today.getDate() - today.getDay() + 7);
        var endOfWeekFormatted = endOfWeek.toISOString().substring(0, 10);
        this.selectDate.start = startOfWeekFormatted;
        this.selectDate.end = endOfWeekFormatted;
    },
    computed:{
          ...mapState([
              'baseUrl'
          ])
      },
    methods:{
        ...mapActions([
            'getEventLogs',
            'exportEventLogs'
            ]),
        
        
        setStartandEndDate(){
            if(this.selectDate.start != null && this.selectDate.end != null) this.getEventLogsF();
        },
        getEventLogsF(){
            
            var form = {}
            form.filter = this.filter
            form.beginDate = this.selectDate.start
            form.endDate = this.selectDate.end
            
            

            this.getEventLogs(form).then((res)=>{
                return res
            }).then((res)=>{
               this.tableRows = res.content.logs
            })
        },
        
        
        exportEventLogsF(){

            axios({
                method:'POST',
                url:'/exportEventLogs',
                data:{
                    language:this.exportLang,
                    beginDate:this.selectDate.start,
                    endDate:this.selectDate.end
                },
                baseURL: this.baseUrl,
                withCredentials:true
                
            }).then((res)=>{
                    return res
            }).then((res)=>{
                
                 
                if(res.data.status.code==0 && res.data.content.link){
                    window.open(res.data.content.link,'_blank')
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                }
            })
        },
      

    },
    
    
    
    mounted(){
        this.getEventLogsF()
         
        if(this.$ml.current=="en"){
            this.exportLang="eng"
        }
        else{
            this.exportLang="tur"
        }
    }
}
</script>



<style scoped>
    * {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    }
    @media (max-width: 992px){
        .table-wrapper {
            overflow-x: auto;
        }
        #dealreport-wrapper{
            margin-left: -0.7em;
            padding-right: 3%;
        }
    }

 


</style>